import { render, staticRenderFns } from "./GroceryDialog.vue?vue&type=template&id=221787fe"
import script from "./GroceryDialog.vue?vue&type=script&lang=js"
export * from "./GroceryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports